var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgE3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 120,
    viewBox: "0 0 121 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.021 60.0014C120.021 26.8643 93.1583 0.00140737 60.0212 0.00140882C26.8842 0.00141026 0.0212362 26.8643 0.0212376 60.0014C0.0212391 93.1385 26.8842 120.001 60.0212 120.001C93.1583 120.001 120.021 93.1385 120.021 60.0014Z",
    fill: "#FFC65F"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7873 57.195C44.7177 57.195 47.9038 53.5605 47.9038 49.0771C47.9038 44.5937 44.7177 40.9592 40.7873 40.9592C36.857 40.9592 33.6709 44.5937 33.6709 49.0771C33.6709 53.5605 36.857 57.195 40.7873 57.195Z",
    fill: "#939598"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.3697 49.0771C86.3697 53.5586 83.1808 57.195 79.2532 57.195C75.3257 57.195 72.1367 53.5586 72.1367 49.0771C72.1367 44.5955 75.3257 40.9592 79.2532 40.9592C83.1808 40.9592 86.3697 44.5955 86.3697 49.0771Z",
    fill: "#939598"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7503 36.1296C41.185 35.3839 37.4634 35.8384 34.1822 37.4222C33.0458 37.962 31.604 37.7418 30.8796 36.7333C30.1623 35.7248 30.7091 34.1055 32.2219 33.3739C36.3981 31.3569 41.1282 30.7816 45.6665 31.7333C47.3142 32.0742 48.2376 33.516 47.783 34.6665C47.3285 35.8242 45.9861 36.3853 44.7503 36.1296Z",
    fill: "#939598"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75.283 36.1296C78.8484 35.3839 82.57 35.8384 85.8512 37.4222C86.9876 37.962 88.4294 37.7418 89.1538 36.7333C89.8711 35.7248 89.3242 34.1055 87.8114 33.3739C83.6353 31.3569 78.9052 30.7816 74.3669 31.7333C72.7191 32.0742 71.7958 33.516 72.2503 34.6665C72.7049 35.8242 74.0472 36.3853 75.283 36.1296Z",
    fill: "#939598"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0731 88.7148H42.968C41.1214 88.7148 39.6299 87.2163 39.6299 85.3768C39.6299 83.5373 41.1285 82.0387 42.968 82.0387H77.0731C78.9197 82.0387 80.4112 83.5373 80.4112 85.3768C80.4112 87.2163 78.9126 88.7148 77.0731 88.7148Z",
    fill: "#939598"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgE3);
export default __webpack_public_path__ + "static/media/E3.4260983d898ad6851eeebbaa31541de4.svg";
export { ForwardRef as ReactComponent };